export default "__VITE_ASSET__Q$jkJat9__"